import { render, staticRenderFns } from "./CtrlDisponibilidadePage.vue?vue&type=template&id=4fd6be31"
import script from "./CtrlDisponibilidadePage.vue?vue&type=script&lang=js"
export * from "./CtrlDisponibilidadePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports